import { render, staticRenderFns } from "./account.vue?vue&type=template&id=1379ed7c&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1379ed7c')) {
      api.createRecord('1379ed7c', component.options)
    } else {
      api.reload('1379ed7c', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=1379ed7c&", function () {
      api.rerender('1379ed7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/pages/account.vue"
export default component.exports